import { ActionMenu } from "layouts/common/buttons";
import { PermissionButton } from "layouts/common/buttons";
import { TextLink } from "layouts/common/buttons";
import MDTypography from "ui/MDTypography";

export default function data(karkuns, handleDelete,) {

const rows = () => {
  return karkuns
    ?.sort((a, b) => {
      // Example: PKLHR01-03
      const [firstA, secondA] = a.karkunid.split("-");
      const [firstB, secondB] = b.karkunid.split("-");

      // Extract numbers (01 → 1)
      const mainA = parseInt(firstA.replace(/\D/g, ''), 10);
      const mainB = parseInt(firstB.replace(/\D/g, ''), 10);

      const subA = parseInt(secondA, 10);
      const subB = parseInt(secondB, 10);

      // Pehle main number compare, phir sub
      if (mainA !== mainB) return mainA - mainB;
      return subA - subB;
    })
    .map(karkun => {
      var { users } = karkun;
      return {
        name: (
          <PermissionButton permissions={["karkun:view"]}>
            <TextLink
              link={`/karkuns/${karkun.id}/detail`}
              text={karkun.name}
            />
          </PermissionButton>
        ),
        phone: (
          <MDTypography variant="caption" fontWeight="medium">
            {karkun.phone}
          </MDTypography>
        ),
        centerName: (
          <MDTypography variant="caption" fontWeight="medium">
            {karkun.centerName}
          </MDTypography>
        ),
        karkunid: (
          <MDTypography variant="caption" fontWeight="medium">
            {karkun.karkunid}
          </MDTypography>
        ),
        dropdown: (
          <ActionMenu
            entity={karkun}
            basePath="karkuns"
            onDelete={() => handleDelete(karkun.id)}
          />
        ),
      };
    });
};


  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Karkun Id", accessor: "karkunid", align: "left" },
      { Header: "Contact", accessor: "phone", align: "left" }, // Add status column
      { Header: "Center Title", accessor: "centerName", align: "left" },
      { accessor: "dropdown", align: "right" },
    ],
    rows: rows()
  };
}